import React from "react";
import "../css/RejectModal.css";
import { CircularProgress } from "@mui/material";
import { REJECT_REASONS } from "../../utils/constants";

const RejectModal = ({
  selectedReason,
  onReasonChange,
  onRejectClick,
  isLoading,
}) => {
  return (
    <div className="reject-modal-content">
      <h2 className="reject-modal-title" data-testid="reject-modal-title">Reject</h2>
      <p className="reject-modal-description">Select a reason to reject</p>
      <form onSubmit={onRejectClick} className="reject-modal-form">
        {Object.values(REJECT_REASONS).map(
          (reason, index) => (
            <div key={index} className="reject-radio-container">
              <input
                type="radio"
                id={`reason-${index}`}
                name="reject-reason"
                value={reason}
                checked={selectedReason === reason}
                onChange={onReasonChange}
                className="reject-radio-input"
              />
              <label htmlFor={`reason-${index}`} className="reject-radio-label">
                {reason.split('_')
                  .map(word => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1))
                  .join(' ')}
              </label>
            </div>
          )
        )}
        <button className="reject-button" data-testid="reject-button">
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Reject"
          )}
        </button>
      </form>
    </div>
  );
};

export default RejectModal;
